const BADGES = [
    {
        src: "https://customer-assets.emergentagent.com/job_serrurerie-atelier/artifacts/x9to35vk_artisan%20serrurier.jpg",
        alt: "Chambre de Métiers et de l'Artisanat — CMA",
        label: "Inscrit CMA",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_serrurerie-atelier/artifacts/t9krimpt_devis-gratuit.png",
        alt: "Devis gratuit",
        label: "Devis gratuit",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_serrurerie-atelier/artifacts/kczqfo00_artisan%20serrurier%20beauchamp.jpeg",
        alt: "Artisan Serrurier Beauchamp",
        label: "Artisan certifié",
    },
];

const TrustBadges = () => {
    return (
        <section
            data-testid="trust-badges"
            aria-label="Certifications et engagements"
            className="bg-white border-t border-black/10"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
                <div className="text-center mb-6 sm:mb-8">
                    <div className="text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500">
                        ◉ Certifications & engagements
                    </div>
                </div>
                <div className="grid grid-cols-3 gap-4 sm:gap-8 items-center">
                    {BADGES.map((b) => (
                        <div
                            key={b.label}
                            data-testid={`trust-badge-${b.label}`}
                            className="flex flex-col items-center justify-center gap-3"
                        >
                            <div className="h-20 sm:h-24 lg:h-28 w-full flex items-center justify-center">
                                <img
                                    src={b.src}
                                    alt={b.alt}
                                    className="max-h-full max-w-full object-contain"
                                    loading="lazy"
                                />
                            </div>
                            <div className="text-[10px] sm:text-xs uppercase tracking-[0.18em] font-semibold text-zinc-700 text-center">
                                {b.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustBadges;
